import Component from '../core/Component';

const ease = {
    //exponentialIn: (t) => {
    //    return t == 0.0 ? t : Math.pow(2.0, 10.0 * (t - 1.0));
    //},
    //exponentialOut: (t) => {
    //    return t == 1.0 ? t : 1.0 - Math.pow(2.0, -10.0 * t);
    //},
    //exponentialInOut: (t) => {
    //    return t == 0.0 || t == 1.0
    //        ? t
    //        : t < 0.5
    //            ? +0.5 * Math.pow(2.0, (20.0 * t) - 10.0)
    //            : -0.5 * Math.pow(2.0, 10.0 - (t * 20.0)) + 1.0;
    //},
    //sineOut: (t) => {
    //    const HALF_PI = 1.5707963267948966;
    //    return Math.sin(t * HALF_PI);
    //},
    //circularInOut: (t) => {
    //    return t < 0.5
    //        ? 0.5 * (1.0 - Math.sqrt(1.0 - 4.0 * t * t))
    //        : 0.5 * (Math.sqrt((3.0 - 2.0 * t) * (2.0 * t - 1.0)) + 1.0);
    //},
    //cubicIn: (t) => {
    //    return t * t * t;
    //},
    //cubicOut: (t) => {
    //    const f = t - 1.0;
    //    return f * f * f + 1.0;
    //},
    cubicInOut: (t) => {
        return t < 0.5
            ? 4.0 * t * t * t
            : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0;
    },
    //quadraticOut: (t) => {
    //    return -t * (t - 2.0);
    //},
    //quarticOut: (t) => {
    //    return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
    //},
}

export default class Menu extends Component {

    constructor(element) {
        super(element);

        if (window.innerWidth <= 767) {
            this.numPoints = 4;  // Number of control points for Bezier Curve.
        } else if (window.innerWidth >= 767 && window.innerWidth <= 1200) {
            this.numPoints = 9;
        } else {
            this.numPoints = 18;
        }

        this.main = document.querySelector('.main');
        // svg
        this.elm = document.querySelector('.liquid'); // Parent SVG element.
        this.path = this.elm.querySelectorAll('path'); // Path elements in parent SVG. These are the layers of the overlay.
        this.duration = 800; // Animation duration of one path element.
        this.delayPointsArray = []; // Array of control points for Bezier Curve.
        this.delayPointsMax = 800; // Max of delay value in all control points.
        this.delayPerPath = 60; // Delay value per path.
        this.timeStart = Date.now();
        this.isOpened = false;
    }

    require = async function() {
        const TweenLite = await import('TweenLite');
        return TweenLite;
    }

    prepare(TweenLite) {
        this.menuItemElements = this.element.querySelectorAll('[data-component="AnimateText"]');

        this.menuItem = [];
        this.menuItemElements.forEach(item => {
            this.menuItem.push(Component.getFromElement(item));
        })
    }

    open() {
        console.log(this.isAnimating || !document.documentElement.classList.contains('menu-is-opened'))
        if (this.isAnimating || document.documentElement.classList.contains('menu-is-opened')) {
            return false;
        }
        this.isAnimating = true;
        this.generatePoints();

        document.documentElement.classList.add('menu-is-opened');

        // svg
        this.isOpened = true;
        this.elm.classList.add('is-opened');
        this.timeStart = Date.now();
        TweenLite.ticker.addEventListener("tick", ::this.renderLoop);
        //TweenLite.to(this.main, this.duration/1000/3, {
        //    opacity: 0.4
        //})
        setTimeout(() => {
            this.menuItem.forEach((item, index) => {
                setTimeout(() => {
                    item.component.animate();
                }, index*200)
            });
            this.ref.menuItems.forEach((item, index) => {
                setTimeout(() => {
                    TweenLite.fromTo(item, .4, {
                        opacity: 0,
                        y: 40,
                        transform: "translateY(40px) scale(1)",
                        force3D: true
                    }, {
                        opacity: 1,
                        y: 0,
                    })
                }, index*200)
            });
        }, 800)
    }

    close() {
        console.log(this.isAnimating || !document.documentElement.classList.contains('menu-is-opened'))
        if (this.isAnimating || !document.documentElement.classList.contains('menu-is-opened')) {
            return false;
        }
        this.isAnimating = true;
        this.generatePoints();

        document.documentElement.classList.remove('menu-is-opened');

        this.menuItem.forEach(item => {
            item.component.reset();
        });

        this.ref.menuItems.forEach((item, index) => {
            setTimeout(() => {
                TweenLite.fromTo(item, .4, {
                    opacity: 1,
                    y: 0,
                    force3D: true
                }, {
                    opacity: 0,
                    y: 20,
                    transform: "scale(0.8)"
                })
            }, index*100)
        });

        // svg
        this.isOpened = false;
        this.elm.classList.remove('is-opened');
        this.timeStart = Date.now();
        TweenLite.ticker.addEventListener("tick", ::this.renderLoop);
        //TweenLite.to(this.main, this.duration/1000/3, {
        //    opacity: 1
        //})
    }

    generatePoints() {
        for (var i = 0; i < this.numPoints; i++) {
            this.delayPointsArray[i] = Math.random() * this.delayPointsMax;
        }
    }

    updatePath(time) {
        const points = [];
        for (var i = 0; i < this.numPoints; i++) {
            points[i] = (1 - ease.cubicInOut(Math.min(Math.max(time - this.delayPointsArray[i], 0) / this.duration, 1))) * 100
        }

        let str = '';
        str += (this.isOpened) ? `M 0 0 V ${points[0]}` : `M 0 ${points[0]}`;
        for (var i = 0; i < this.numPoints - 1; i++) {
            const p = (i + 1) / (this.numPoints - 1) * 100;
            const cp = p - (1 / (this.numPoints - 1) * 100) / 2;
            str += `C ${cp} ${points[i]} ${cp} ${points[i + 1]} ${p} ${points[i + 1]} `;
        }
        str += (this.isOpened) ? `V 100 H 0` : `V 0 H 0`;

        return str;
    }

    render() {
        if (this.isOpened) {
            for (var i = 0; i < this.path.length; i++) {
                this.path[i].setAttribute('d', this.updatePath(Date.now() - (this.timeStart + this.delayPerPath * i)));
            }
        } else {
            for (var i = 0; i < this.path.length; i++) {
                this.path[i].setAttribute('d', this.updatePath(Date.now() - (this.timeStart + this.delayPerPath * (this.path.length - i - 1))));
            }
        }
    }

    renderLoop() {
        this.render();
        if (Date.now() - this.timeStart > this.duration + this.delayPerPath * (this.path.length - 1) + this.delayPointsMax) {
            TweenLite.ticker.removeEventListener("tick", ::this.renderLoop);
            this.isAnimating = false;
        }
    }

}



// WEBPACK FOOTER //
// ./components/Menu.js